import Observer from '~/utils/lib/core/observer'

/**
 * @constant {string}
 * @default
 */
export const STORE_PREFIX = 'layout'

/** @constant {object} */
export const EVENTS = {
  ON_ANONYMOUS_USER_CATCHED: 'layout/onAnonymousUserCatched',
  ON_MODAL_SHOW_INTENT: 'layout/onModalShowIntent',
  ON_MODAL_HIDE_INTENT: 'layout/onModalHideIntent',
  ON_MODAL_HIDE_SUCCESS: 'layout/onModalHideSuccess',
  ON_MODAL_SHOW_SUCCESS: 'layout/onModalShowSuccess',
}

/**
 * @constant {import('vue-router').RouteLocationNormalizedGeneric["path"]}
 * @default "/account/authentication"
 */
export const DEFAULT_ANONYMOUS_ROUTE = '/account/authentication'

/**
* @constant {import('vue-router').RouteLocationNormalizedGeneric["path"]}
* @default "/dashboard"
*/
export const DEFAULT_USER_ROUTE = '/landing/user-nil-access'

/** @constant {object} */
export const ERRORS = {
  UNKNOWN_STRUCTURE: 'unknown_structure',
  UNKNOWN_COMPANY: 'unknown_company',
  UNKNOWN_PRODUCT: 'unknown_product',
}

/** @enum {typeof NAVIGATION_SCOPE [keyof typeof NAVIGATION_SCOPE]} */
export const NAVIGATION_SCOPE = /** @const */ ({
  DATA_ONLY: 'DATA_ONLY',
  COMPANY_OPTIONAL: 'COMPANY_OPTIONAL',
  COMPANY_REQUIRED: 'COMPANY_REQUIRED',
})


/** @enum {typeof PRODUCT[keyof typeof PRODUCT]} */
export const PRODUCT = /** @type {const} */ ({
  HIRE: 'product_hire',   // HAMAC | HIRE | "Embauches en contrat court"
  LEAVE: 'product_leave',  // TRANSAT | LEAVE | "Congés & Absences"
  DASHBOARD: 'dashboard',  // DASHBOARD | "Tableau de bord, homepage"
  CLIENT_ACCOUNT: 'compte_client',  // CLIENT_ACCOUNT | "Fiche client, Fiche contact"
  GED: 'ged',  // GED | "Gestion documentaire"
  PARAMETERS: 'parasol_parameters', // "Parasol: Parameters"
  SATD: 'satd', // SATD | "Satd"
  SALARIES: 'salaries',
})

/**
 * @enum {typeof MENU_ITEM[keyof typeof MENU_ITEM]}
 */
export const MENU_ITEM = /** @type {const} */ ({
  // =========================
  //    SERVICE
  // =========================
  DASHBOARD: 'dashboard',
  EMBAUCHE: 'embauche',
  ABSENCES: 'absences',
  DOCUMENTS: 'documents',
  EMPLOYEURS: 'employeurs',
  ACTIONS_REQUISES: 'actions_requises',
  SATD: 'satd',
  PAIES: 'paies',
  SALARIES: 'salaries',

  // =========================
  //    PARAMETERS
  // =========================
  PARAMETERS_GENERAL: 'parameters_general',
  PARAMETERS_USER_MANAGEMENT: 'parameters_user_management',
  PARAMETERS_BILLING: 'parameters_billing',
  PARAMETERS_ACHATS: 'parameters_achats',
  PARAMETERS_SIGNATURES: 'parameters_signatures',
})

/** @type {Observer} */
export const observer = new Observer()
